import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { ResourcePath } from './ResourcePath';
import { QueryKey } from './types';

export enum FilterType {
	CurrentUserOnly = 'current_user_only',
	Department = 'department',
	Hashtag = 'hashtag',
	Location = 'location',
	RecognitionType = 'recognition_type',
	Relevance = 'relevance',
	Team = 'team',
}

export interface Option {
	name: string;
	value: string | boolean;
}

export interface Filter {
	filter_type: FilterType;
	options: Option[];
}

export type RecognitionFeedFilterOptionsResponse = {
	data: Filter[];
};

export const useRecognitionFeedFilterOptions = () => {
	const http = useHttpClient('v2');

	return useQuery([QueryKey.RecognitionFeedFilterOptions], () => http.get<RecognitionFeedFilterOptionsResponse>(ResourcePath.RecognitionFeedFilterOptions), {
		select: (data) => data?.data.data,
	});
};
